module.exports = __webpack_public_path__ + "cjml_app_pcui/img/pic_01.90065062.png";